// src/api/admin.js
import adminRequest from "./adminClient";

export const adminLogin = (payload) =>
    adminRequest("/admin/login", { method: "POST", body: payload });

export const adminMe = () =>
    adminRequest("/admin/me");

export const adminRegister = (payload) =>
    adminRequest("/admin/register", { method: "POST", body: payload });

export const listAdmins = () =>
    adminRequest("/admin");

export const deleteAdmin = (id) =>
    adminRequest(`/admin/${id}`, { method: "DELETE" });


export const adminSearchUsers = ({ q = "", skip = 0, limit = 20 } = {}) => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (skip) params.set("skip", String(skip));
    if (limit) params.set("limit", String(limit));
    return adminRequest(`/admin/users?${params.toString()}`);
};

// 상세: /admin/users/:id
export const adminGetUser = (id) =>
    adminRequest(`/admin/users/${id}`);

// 수정(멀티파트): /admin/users/:id
export const adminUpdateUser = (id, payload = {}) => {
    const fd = new FormData();
    // 문자열/불리언 필드 (값이 있으면만 전송)
    for (const [k, v] of Object.entries(payload)) {
        if (v === undefined || v === null) continue;
        if (k === "image") continue; // 파일은 아래에서
        fd.append(k, typeof v === "boolean" ? String(v) : v);
    }
    if (payload.image instanceof File) {
        fd.append("image", payload.image);
    }
    return adminRequest(`/admin/users/${id}`, { method: "PUT", body: fd });
};


export const adminSearchMeasurements = ({
    q = "",
    start = "",
    end = "",
    user_id = "",
    skip = 0,
    limit = 30,
} = {}) => {
    const params = new URLSearchParams();

    if (q) params.set("q", q);
    if (start) params.set("start", start);
    if (end) params.set("end", end);
    if (user_id) params.set("user_id", String(user_id));
    if (skip) params.set("skip", String(skip));
    if (limit) params.set("limit", String(limit));

    return adminRequest(`/admin/measurements?${params.toString()}`);
};

export const adminGetMachineSettings = (userId) =>
    adminRequest(`/admin/users/${userId}/settings/machines`);

export const adminSaveMachineSetting = (userId, machineKey, payload) =>
    adminRequest(`/admin/users/${userId}/settings/machines/${machineKey}`, {
        method: "PUT",
        body: payload,
    });

export const adminGetCardioSettings = (userId) =>
    adminRequest(`/admin/users/${userId}/settings/cardio`);

export const adminSaveCardioSetting = (userId, cardioType, payload) =>
    adminRequest(`/admin/users/${userId}/settings/cardio/${cardioType}`, {
        method: "PUT",
        body: payload,
    });
